<template>
  <div class="form-lower entry-detail">
    <header class="gnav">
      <h1 class="sp">
        <img src="@/assets/img/client/logo.png" alt="GLOCALY">
      </h1>
      <nav class="gnav_inner">
        <ul>
          <li class="pc">
            <h1>
              <a disabled="disabled" style="pointer-events: none; cursor: default;"><img src="@/assets/img/client/logo.png" alt="GLOCALY"></a>
            </h1>
          </li>
        </ul>
      </nav>
      <lang />
    </header>
    <section class="entry-detail-contents wrapper">
      <h2>{{ $t('Please enter your information') }}</h2>
      <p class="intro" v-html="$t('entry_detail_header1')"></p>
      <form>
        <div class="entry-detail-wrapper">
          <dl class="entry-detail-item input-form">
            <dt>{{ $t('plan_id') }}<span class="hiss">＊</span></dt>
            <dd>
              <select class="w-50" name="plan_id" id="plan_id" v-model="$v.memberAccount.plan_id.$model" :state="validateState('plan_id')">
                <option :value="null" disabled selected>{{ $t(['please_choose']) }}</option>
                <option v-for="(plan, index) in plans" :key="index" :value="plan.id">{{plan.name}}</option>
                <option :value="'FREE_PLAN'">{{ $t('label_free-plan') }}</option>
              </select>
              <a @click="showModal('about-plan')">{{ $t('label_about-plan') }}</a>
              <b-form-invalid-feedback :state="validateState('plan_id')">
                <p v-if="!$v.memberAccount.plan_id.required">{{ $t('is required').replace('%s', $t('plan_id')) }}</p>
              </b-form-invalid-feedback>
            </dd>
            <dt class="hr">{{ $t('name') }}<span class="hiss">＊</span></dt>
            <dd>
              <input type="text" v-model="$v.memberAccount.fullname.$model" name="name" id="name" placeholder="山田太郎" :state="validateState('fullname')">
                <b-form-invalid-feedback :state="validateState('fullname')">
                    <p v-if="!$v.memberAccount.fullname.required">{{ $t('is required').replace('%s', $t('name')) }}</p>
                    <p v-if="!$v.memberAccount.fullname.maxLength">{{ $t('less than').replace('%s', $t('name').toLowerCase()).replace('%d', '30') }}</p>
                    <p v-if="!$v.memberAccount.fullname.minLength">{{ $t('more than').replace('%s', $t('name').toLowerCase()).replace('%d', $v.memberAccount.fullname.$params.minLength.min) }}</p>
                </b-form-invalid-feedback>
            </dd>
            <dt v-show="activeLanguage === 'ja'">フリガナ</dt>
            <dd v-show="activeLanguage === 'ja'">
              <input type="text" v-model="$v.memberAccount.fullname_furigana.$model" name="name_kana" id="name_kana" placeholder="ヤマダタロウ" :state="validateState('fullname_furigana')">
                <b-form-invalid-feedback :state="validateState('fullname_furigana')">
                    <p v-if="!$v.memberAccount.fullname_furigana.maxLength">30文字以下で入力してください</p>
                    <p v-if="!$v.memberAccount.fullname_furigana.minLength">フリガナは{{$v.memberAccount.fullname_furigana.$params.minLength.min}}文字以上入力してください</p>
                </b-form-invalid-feedback>
            </dd>
            <dt class="l2">{{ $t('password_for_login') }}<span class="hiss">＊</span><br><span class="fontS">{{ $t('for_login') }}</span></dt>
            <dd>
              <input :type="passwordShowHide" v-model="$v.memberAccount.password.$model" name="pw" id="pw" :state="validateState('password')">
              <span class="field-icon" @click="showPassword = !showPassword">
                <img src="@/assets/img/client/mdi-eye.png" alt="" width="33" height="21" v-if="showPassword">
                <img src="@/assets/img/client/mdi-eye-off.png" alt="" width="33" height="21" v-else>
              </span>
              <b-form-invalid-feedback :state="validateState('password')">
                <p v-if="!$v.memberAccount.password.required">{{ $t('is required').replace('%s', $t('password_for_login').toLowerCase()) }}</p>
                <p v-if="!$v.memberAccount.password.minLength">{{ $t('more than').replace('%s', $t('password_for_login').toLowerCase()).replace('%d', $v.memberAccount.password.$params.minLength.min) }}</p>
              </b-form-invalid-feedback>
            </dd>
            <dt class="hr">{{ $t( 'country' )}}<span class="hiss">＊</span></dt>
            <dd>
              <select name="countries" id="countires" v-model="$v.memberAccount.country.$model" class="w-100" :state="validateState('country')" @change="changeCountry">
                <option :value="null" disabled selected>{{ $t(['please_choose']) }}</option>
                <option v-for="(country, index) in countries" :key="index" :value="country">{{ country }}</option>
              </select>
              <b-form-invalid-feedback :state="validateState('country')">
                <p v-if="!$v.memberAccount.country.required">{{ $t('is required').replace('%s', $t('country')) }}</p>
              </b-form-invalid-feedback>
            </dd>
            <dt>{{ $t('postal_code') }}<span class="hiss">＊</span></dt>
            <dd>
              <input type="text" v-model="$v.memberAccount.postal_code.$model" name="zip" id="zip" placeholder="000-0000" class="inputS"  :state="validateState('postal_code')">
              <b-form-invalid-feedback :state="validateState('postal_code')">
                <p v-if="!$v.memberAccount.postal_code.required">{{ $t('is required').replace('%s', $t('postal_code')) }}</p>
              </b-form-invalid-feedback>
            </dd>
            <dt v-show="activeLanguage === 'ja'">都道府県</dt>
            <dd v-show="activeLanguage === 'ja'">
              <select name="prefectures" id="prefectures" v-model="memberAccount.prefectures" :disabled="memberAccount.country !== 'Japan'">
                <option :value="null" disabled selected>{{ $t(['please_choose']) }}</option>
                <option v-for="(prefecture, index) in prefectures" :key="index" :value="prefecture">{{prefecture}}</option>
              </select>
            </dd>
            <dt>{{ $t('Address') }}<span class="hiss">＊</span></dt>
            <dd>
              <input type="text" v-model="$v.memberAccount.address.$model" name="add" id="add" :placeholder="$t('address-placeholder')" :state="validateState('address')">
              <b-form-invalid-feedback :state="validateState('address')">
                <p v-if="!$v.memberAccount.address.maxLength">{{ $t('less than').replace('%s', $t('name').toLowerCase()).replace('%d', '80') }}</p>
                <p v-if="!$v.memberAccount.address.required">{{ $t('is required').replace('%s', $t('Address')) }}</p>
              </b-form-invalid-feedback>
            </dd>
            <dt class="hr">{{ $t('phone_number') }}</dt>
            <dd>
              <input type="tel" v-model="memberAccount.phone_number" name="tel" id="tel" placeholder="00-0000-0000" class="inputS">
            </dd>
            <dt>{{ $t('fax_number') }}</dt>
            <dd>
              <input type="tel" v-model="memberAccount.fax_number" name="fax" id="fax" placeholder="00-0000-0000" class="inputS">
              </dd>
            <dt class="hr">{{ $t('age') }}<span class="hiss">＊</span></dt>
            <dd>
              <select v-model="$v.memberAccount.age.$model" name="age" id="age"  :state="validateState('age')">
                <option value="null" disabled selected>{{ $t(['please_choose']) }}</option>
                <option v-for="(item, index) in ageSetup" :key="index" :value="item">{{item + $t('exts')}}</option>
              </select>
              <b-form-invalid-feedback :state="validateState('age')">
                <p v-if="!$v.memberAccount.age.required">{{ $t('is required').replace('%s', $t('age')) }}</p>
              </b-form-invalid-feedback>
            </dd>
            <dt>{{ $t('sex') }}<span class="hiss">＊</span></dt>
            <dd>
              <input type="radio" v-model="$v.memberAccount.gender.$model" name="sex" id="man" value="Male"><label for="man" class="radioTxt" :state="validateState('gender')">{{ $t('male') }}</label>
              <input type="radio" v-model="$v.memberAccount.gender.$model" name="sex" id="woman" value="Female"><label for="woman" class="radioTxt" :state="validateState('gender')">{{ $t('female') }}</label>
              <b-form-invalid-feedback :state="validateState('gender')">
                <p v-if="!$v.memberAccount.gender.required">{{ $t('is required').replace('%s', $t('sex')) }}</p>
              </b-form-invalid-feedback>
            </dd>
            <dt class="hr">{{ $t('company_name') }}</dt>
            <dd>
              <input type="text" :placeholder="$t('company_name-placeholder')" v-model="memberAccount.company_name">
            </dd>
            <dt>
              {{ $t('company_detail') }}
              <div v-html="$t('company_detail_caution1')"></div>
            </dt>
            <dd>
              <textarea :placeholder="$t('company_detail-placeholder')" rows="5" v-model="memberAccount.company_description"></textarea>
              <div v-html="$t('company_detail_caution2')"></div>
            </dd>
          </dl>
          <dl class="entry-detail-item input-form">
            <dt>{{ $t('business_type')  }}<span class="hiss">＊</span></dt>
            <dd>
              <input type="checkbox" id="business_type_indivisual" v-model="$v.memberAccount.business_type_indivisual.$model">
              <label for="business_type_indivisual" class="checkbox">{{ $t('business_type_indivisual') }}</label>
              <input type="checkbox" id="business_type_developer" v-model="$v.memberAccount.business_type_developer.$model">
              <label for="business_type_developer" class="checkbox">{{ $t('business_type_developer') }}</label>
              <input type="checkbox" id="business_type_mediator" v-model="$v.memberAccount.business_type_mediator.$model">
              <label for="business_type_mediator" class="checkbox">{{ $t('business_type_mediator') }}</label>
              <b-form-invalid-feedback :state="validateState('business_type_developer')">
                <p v-if="!$v.memberAccount.business_type_developer.businessTypeValidation">{{ $t('is required').replace('%s', $t('business_type')) }}</p>
              </b-form-invalid-feedback>
            </dd>
            <dt>{{ $t('area') }}<span class="hiss">＊</span></dt>
            <dd>
              <select v-model="$v.memberAccount.area.$model" name="area" id="area" :state="validateState('area')">
                <option :value="null" disabled selected>{{ $t(['please_choose']) }}</option>
                <option v-for="(prefecture, index) in prefectures" :key="index" :value="prefecture">{{ $t(index) }}</option>
              </select>
              <b-form-invalid-feedback :state="validateState('area')">
                <p v-if="!$v.memberAccount.area.required">{{ $t('is required').replace('%s', $t('area')) }}</p>
              </b-form-invalid-feedback>
            </dd>
            <dt>{{ $t('area_detail')  }}</dt>
            <dd>
              <textarea :placeholder="$t('area_detail-placeholder')" rows="5" v-model="memberAccount.area_detail"></textarea>
            </dd>
            <dt>{{ $t('property_use') }}<span class="hiss">＊</span></dt>
            <dd>
              <span v-for="(item, index) in propertyUses" :key="item">
                <input @change="toggleType" type="radio" v-model="$v.memberAccount.use_of_the_property.$model" name="use" class="useSelect" :id="`property-use-${index}`" :value="item"><label :for="`property-use-${index}`" class="radioTxt">{{ $t(item) }}</label>
              </span>
              <b-form-invalid-feedback :state="validateState('use_of_the_property')">
                <p v-if="!$v.memberAccount.use_of_the_property.required">{{ $t('is required').replace('%s', $t('property_use')) }}</p>
              </b-form-invalid-feedback>
            </dd>
            <dt>{{ $t('property_type_under_consideration') }}<span class="hiss">＊</span></dt>
            <dd>
              <div class="select_property_type">
                <select v-model="$v.memberAccount.types_of_properties.$model" name="type" :state="validateState('types_of_properties')" :disabled="memberAccount.use_of_the_property == null">
                  <option :value="null" disabled selected>{{ $t('please_choose') }}</option>
                  <option v-for="item in propertyType" :key="item" :value="item">{{$t(item)}}</option>
                </select>
              </div>
              <b-form-invalid-feedback :state="validateState('types_of_properties')">
                <p v-if="!$v.memberAccount.types_of_properties.required">{{ $t('is required').replace('%s', $t('property_type_under_consideration')) }}</p>
              </b-form-invalid-feedback>
            </dd>
            <dt>{{ $t('preferred_range') }}<span class="hiss">＊</span></dt>
            <dd>
              <select v-model="$v.memberAccount.desired_price_range.$model" name="price_range" id="price_range" :state="validateState('desired_price_range')">
                <option :value="null" disabled selected>{{ $t('please_choose') }}</option>
                <option v-for="item in price" :key="item" :value="item">{{$t(item)}}</option>
              </select>
              <b-form-invalid-feedback :state="validateState('desired_price_range')">
                <p v-if="!$v.memberAccount.desired_price_range.required">{{ $t('is required').replace('%s', $t('preferred_range')) }}</p>
              </b-form-invalid-feedback>
            </dd>
            <dt class="hr">{{ $t('email_distribution') }}<span class="hiss">＊</span></dt>
            <dd>
              <input type="radio" v-model="$v.memberAccount.email_magazine_delivery.$model" name="newsletter" id="ok" value="ok"><label for="ok" class="radioTxt" :state="validateState('email_magazine_delivery')">{{ $t('want') }}</label>
              <input type="radio" v-model="$v.memberAccount.email_magazine_delivery.$model" name="newsletter" id="ng" value="ng"><label for="ng" class="radioTxt" :state="validateState('email_magazine_delivery')">{{ $t('dont_want') }}</label>
            </dd>
          </dl>
        </div>
        <div class="submit">
          <p v-html="$t('policy-explanation')"></p>
          <div class="input-form">
            <input type="checkbox" id="policy-checkbox" v-model="agreementChecked">
            <label for="policy-checkbox" class="checkbox">{{ $t('policy-checkbox') }}</label>
          </div>
          <a type="button" :class="{brown_btn: true, disabled: !agreementChecked}" @click="memberInformation">{{ $t('policy_aggreement') }}</a>
          <div class="html_entry-caution" v-html="$t('html_entry-caution')"></div>
          <div v-show="status" class="py-3 px-5 my-4">
            <p class="m-0">{{ status }}</p>
          </div>
        </div>
      </form>
    </section>
    <modal name="about-plan" height="auto" :reset="true">
      <div class="modal-header">
        <h2>{{ $t('label_about-plan') }}</h2>
      </div>
      <div class="modal-body">
        <div v-html="$t('html_about-plan')"></div>
        <button class="white_btn" @click="hideModal('about-plan')">{{ $t('label_close') }}</button>
      </div>
    </modal>
  </div>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import lang from '@/components/client/language/language'
import { mapState, mapActions } from 'vuex'
import Vue from 'vue'
import { memberAges, businessPropertyValues, propertyUses, propertyPrices } from '../../../assets/data/values'

const businessTypeValidation = (_value, vm) => {
  return vm.business_type_developer || vm.business_type_mediator || vm.business_type_indivisual
}

export default {
  data () {
    return {
      currentlanguage: Vue.$cookies.get('language'),
      status: null,
      showPassword: false,
      agreementChecked: false,
      memberAccount: {
        fullname: null,
        fullname_furigana: null,
        password: null,
        postal_code: null,
        prefectures: null,
        country: Vue.$cookies.get('language') === 'ja' ? 'Japan' : null,
        address: null,
        phone_number: null,
        fax_number: null,
        age: null,
        gender: null,
        use_of_the_property: null,
        desired_price_range: null,
        types_of_properties: null,
        language: this.$route.params.lang,
        email_magazine_delivery: 'ok',
        plan_id: null,
        area: null,
        area_detail: null,
        business_type_developer: false,
        business_type_mediator: false,
        business_type_indivisual: false,
        company_name: null,
        company_description: null
      },
      residentialList: businessPropertyValues.propertyTypes.residential,
      investmentList: businessPropertyValues.propertyTypes.investment,
      propertyUses: propertyUses,
      price: propertyPrices,
      ageSetup: memberAges
    }
  },
  validations: {
    memberAccount: {
      fullname: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(30)
      },
      fullname_furigana: {
        minLength: minLength(2),
        maxLength: maxLength(30)
      },
      password: {
        required,
        minLength: minLength(8)
      },
      country: { required },
      address: {
        required,
        maxLength: maxLength(80)
      },
      age: { required },
      postal_code: { required },
      gender: { required },
      use_of_the_property: { required },
      desired_price_range: { required },
      types_of_properties: { required },
      email_magazine_delivery: { required },
      plan_id: { required },
      area: { required },
      business_type_developer: { businessTypeValidation },
      business_type_mediator: { businessTypeValidation },
      business_type_indivisual: { businessTypeValidation }
    }
  },
  created () {
    this.prefectureCountryClient()
    this.planClient()
  },
  components: {
    lang
  },
  computed: {
    ...mapState(['language']),
    ...mapState('adminAddMember', ['countries', 'prefectures', 'plans']),
    activeLanguage () {
      if (!this.language && !this.currentlanguage) {
        return 'name_ja'
      } else {
        if (!this.language) {
          return this.currentlanguage
        }
        return this.language
      }
    },
    passwordShowHide () {
      return this.showPassword ? 'text' : 'password'
    },
    currentlanguageRoute () {
      if (this.currentlanguage === 'zh-cn') {
        return 'zh/'
      } else if (this.currentlanguage === 'ja') {
        return ''
      }
      return this.currentlanguage + '/'
    },
    propertyType () {
      if (this.$v.memberAccount.use_of_the_property.$model === 'Residential use') {
        return this.residentialList
      }
      return this.investmentList
    }
  },
  methods: {
    ...mapActions('adminAddMember', ['addNewClient', 'prefectureCountryClient', 'planClient']),
    validateState (name) {
      const { $dirty, $error } = this.$v.memberAccount[name]
      return $dirty ? !$error : null
    },
    memberInformation: function () {
      if (!this.agreementChecked) return

      this.$v.$touch()
      if (this.$v.$invalid) {
        this.status = this.$t('label_form-error')
      } else {
        switch (this.memberAccount.language) {
          case 'ja':
            this.memberAccount.language = 'Japanese'
            break
          case 'en':
            this.memberAccount.language = 'English'
            break
          case 'zh-cn':
            this.memberAccount.language = 'Simplified Chinese'
            break
          case 'zh-tw':
            this.memberAccount.language = 'Traditional Chinese'
            break
        }
        this.addNewClient(this.memberAccount)
        this.$nextTick(() => {
          this.$v.$reset()
        })
        this.status = null
      }
    },
    toggleType: function () {
      this.memberAccount.types_of_properties = null
    },
    changeCountry () {
      if (this.memberAccount.country !== 'Japan') {
        this.memberAccount.prefectures = null
      }
    },
    showModal (name) {
      this.$modal.show(name)
    },
    hideModal (name) {
      this.$modal.hide(name)
    }
  }
}
</script>

<style lang="scss" src="@/assets/sass/client/index.scss">
</style>

<style scoped>
.entry-detail .gnav h1{
  width: 100%;
}
.entry-detail .gnav .gnav_inner a{
  padding: 1.375em 0;
}
.entry-detail-item a{
  font-weight: bold;
  margin-left: 20px;
  position: relative;
  padding-left: 40px;
  top: -10px;
}
.entry-detail-item a::before{
  content: '?';
  color: #fff;
  font-weight: bold;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  position: absolute;
  margin: auto;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: #000;
  text-align: center;
  line-height: 32px;
}
.entry-detail-item dt > div{
  font-size: 0.875em;
  line-height: 1.5;
  color: #BC9B5D;
  padding-right: 40px;
  margin-top: 1em;
}
.entry-detail-item dd > div{
  font-size: 0.875em;
  color: #EA6031;
  margin-top: .5em;
  padding-left: 1em;
  text-indent: -1em;
}
.entry-detail-wrapper > div{
  font-weight: bold;
  background: #F2F2F2;
  max-width: 700px;
  margin: auto;
  padding: 1em;
  text-align: center;
}
.entry-detail .gnav .gnav_inner{
  background: none;
}
.entry-detail-item dd > .select_property_type{
  font-size:1em;
}
.entry-detail .entry-detail-contents .submit{
  padding-bottom: 120px;
}
.entry-detail .entry-detail-contents .submit .input-form {
  text-align: center;
}
.entry-detail .entry-detail-contents .submit .brown_btn.disabled {
  background-color: #F5F0DF;
  border-color: #F5F0DF;
  color: #ccc;
  cursor: not-allowed;
}
.entry-detail .html_entry-caution{
  margin-top: 1.5em;
  text-align: center;
}
@media screen and (min-width:769px) and ( max-width:1024px) {
  .entry-detail .gnav h1{
    width: 100% !important;
  }
  .entry-detail .gnav .gnav_inner a{
    padding: 1.375em 0 !important;
  }
  .entry-detail .gnav .gnav_inner{
    top: 0;
    left: auto;
    padding: 0;
  }
  .entry-detail .gnav .gnav_inner a{
    padding: 0;
  }
  .entry-detail .gnav .gnav_inner > ul li:last-child{
    background: none;
  }
  .entry-detail .lang{
    z-index: 9999;
  }
}
@media screen and (max-width: 768px) {
  .entry-detail .entry-detail-contents p.intro{
    margin-bottom: 20px;
  }
  .entry-detail .entry-detail-contents .entry-detail-wrapper .entry-detail-item{
    padding: .5em 0;
  }
  .entry-detail .entry-detail-contents .entry-detail-wrapper .entry-detail-item dt.hr{
    padding-top: 8px;
  }
  .entry-detail .entry-detail-contents .entry-detail-wrapper .entry-detail-item dt.hr + dd{
    padding-top: 0;
    border-top: none;
  }
  .entry-detail .entry-detail-contents .entry-detail-wrapper .entry-detail-item dt {
    width: 100%;
    margin: 0;
    line-height: 32px;
  }
  .entry-detail-wrapper .entry-detail-item dd {
    width: 100%!important;
    margin-bottom: 16px!important;
  }
  .entry-detail-item a{
    display: block;
    margin: 1em 0 0;
    top: 0;
  }
  .entry-detail-item dt > div{
    padding-right: 0;
    margin-bottom: 0.5em;
  }
  .entry-detail .brown_btn{
    margin: 0 auto;
    padding: 0.75em 0.25em;
    font-size: 1.8rem;
  }
  .entry-detail .entry-detail-contents .submit{
    padding-bottom: 80px;
  }
}
</style>

<style>
.entry-detail .submit .html_entry-caution p{
  text-align-last: left;
  display: inline-block;
}

.entry-detail .submit .html_entry-caution p.annotation{
  font-size: .875em;
  color: #EA6031;
  font-weight: bold;
  margin-bottom: 1.5em;
}

.entry-detail .html_entry-caution span{
  text-indent: -1em;
  padding-left: 1em;
  display: block;
}

.entry-detail .vm--modal{
  max-width: 960px;
}

.entry-detail .modal-body h3{
  font-size: 1.25em;
  margin-top: 40px;
  font-weight: bold;
}

.entry-detail .modal-body a{
  font-weight: bold;
  color: #BC9B5D;
  text-decoration: underline;
  margin-top: 1em;
  display: block;
}

.entry-detail .modal-body a:hover{
  text-decoration: none;
}

.entry-detail .modal-body h3 + p{
  margin-top: 1em;
}
</style>
